var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#003AFF",
    points: "0 44 0 0 32 0 32 44 16.5 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-92",
    fill: "#00FFC2",
    points: "9.65752 26.79941 16.00002 20.45691 22.34252 26.79941 22.34252 31.79011 16.00002 25.44761 9.65752 31.79011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    fill: "#00FFC2",
    points: "9.65752 18.55238 16.00002 12.20988 22.34252 18.55238 22.34252 23.54308 16.00002 17.20058 9.65752 23.54308"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.22d1f3555c8edd6d2e372420acee6e68.svg";
export { ForwardRef as ReactComponent };